import {Col, Container, Row} from "react-bootstrap";
import '../bootstrap.min.css';
import { BsGithub } from "react-icons/bs";
import {Link} from "react-router-dom";
import * as PropTypes from "prop-types";

function LinkContainer(props) {
    return null;
}

LinkContainer.propTypes = {to: PropTypes.string};

function Main() {
    return (
        <div className="text-center">
            <Container>
                    <h3>
                        A platform game where you have to be fast, but not too fast!
                    </h3>
                    Platformer racing in the dark. Race against a blazingly fast AI, but you cannot be too fast...
                    <p/>
                    Otherwise you'll be kept in the dark!
                    <p/>
                    <iframe frameBorder="0" src="https://itch.io/embed/1421303" ><a
                        href="https://luizchagasjardim.itch.io/chaz">Chaz</a></iframe>
                <p/>
                Written in Rust, using Bevy for the first Bevy Game Jam.
                <p/>
                <a href="https://github.com/sousajo-cc/chaz_rs">
                    <BsGithub style={{marginRight: "0.2em",marginBottom:"0.1em"}}>
                    </BsGithub>
                    <span>Chaz</span>
                </a>
                <p/>
                <a href="https://github.com/luizchagasjardim">
                    <BsGithub style={{marginRight: "0.2em",marginBottom:"0.1em"}}>
                    </BsGithub>
                    <span>Luiz Chagas Jardim</span>
                </a>
                <p/>
                <a href="https://github.com/sousajo-cc">
                    <BsGithub style={{marginRight: "0.2em",marginBottom:"0.1em"}}>
                    </BsGithub>
                    <span>Jorge Pinto Sousa</span>
                </a>
            </Container>
        </div>
    )
}
export default Main;